import axios from 'axios';

/**
 * Gets a list of forum Topics
 * @returns {Promise} forum topics - a promise 
 of topics to be resolved
 */
export function getForumTopics(limit, offset) {
	return axios.get(`/v1/forum?limit=${limit}&offset=${offset}`);
}

/**
 * Gets a single forum topic
 * @param {Number} id - Id of forum topic to be resolved
 * @returns {Promise} forum topic - a promise of forum topic to be resolved
 */
export function getForumTopic(id) {
	return axios.get(`/v1/forum/${id}`);
}

/**
 * Creates a new forum post
 * @param {Object} data 
 * @returns {Promise} a promise of forum topic to be created
 */
export function createForumTopic(data) {
	return axios.post('/v1/forum', data);
}

/**
 * Fetches a list of forum categories
 * @returns {promise} a promise of forum categies to be resolved
 */
export function getForumCategories() {
	return axios.get('/v1/forumcategories');
}

/**
 * Creates a new forum thread
 * @param {Number} id - id of forum topic
 * @param {Object} data - object with the content of thread
 * @returns {Promise} a promise of forum topic to be created
 */
export function createForumThread(id, data) {
	return axios.post(`/v1/forum/${id}/thread`, data);
}

/**
 * Report a forum topic
 */
export function reportForumTopic(forumData) {
	return axios.post(`/v1/forum/${forumData.topic_id}/report`, forumData);
}

/**
 * Report a forum comment
 */
export function reportForumComment(forumData) {
	return axios.post(`/v1/forum/${forumData.forum_topic_id}/thread/${forumData.comment_id}/report`, forumData);
}


/**
 * Deletes a forum topic
 * @param {Number} id - id of forum topic
 * @returns {Promise} a promise of forum topic to be created
 */
export function deleteForumTopic(id) {
	return axios.delete(`/v1/forum/${id}`);
}

/**
 * Deletes a forum thread
 * @param {Number} id - id of forum topic
 * @returns {Promise} a promise of forum topic to be created
 */
export function deleteForumThread(forumTopicId, id) {
	return axios.delete(`/v1/forum/${forumTopicId}/thread/${id}`);
}

/**
 * Fetches a forum category
 * @returns {promise} a promise of forum categies to be resolved
 */
export function getForumCategory(id) {
	return axios.get(`/v1/forumcategories/${id}`);
}
